const styles = `:host {
  border-width: 1px;
  border-style: solid;
  background-color: var(--goto-surface-color-default);
  box-shadow: var(--goto-elevation-medium);
  border-color: var(--goto-border-color-default);
  border-radius: var(--goto-radius-small);
  display: inline-flex;
  padding: 0 0.25rem;
}

:host([variant=transparent]) {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
:host([variant=transparent]) ::slotted(chameleon-icon-button) {
  background-color: var(--goto-interactive-color-secondary-default);
  border-radius: var(--goto-radius-small);
}

::slotted(chameleon-icon-button) {
  margin: 3px 0.25rem 3px 0;
}

::slotted(:last-child) {
  margin-right: 0;
}`; export default styles;